import Vue from "vue";
import App from "./App";
import router from "./router";
//import vconsole from '@/utils/vconsole' // eslint-disable-line
import VConsole from "vconsole";
import dsbridge from "@/utils/dsbridge";
import "babel-polyfill";
import "swiper/css/swiper.min.css";
import "normalize.css";
import "./components";

import "./assets/styles/common.less";
import filters from "./filters";
import store from "./store";
import VueBarcode from "vue-barcode";
import {
  Row,
  Col,
  Collapse,
  CollapseItem,
  NavBar,
  Tab,
  Tabs,
  Cell,
  CellGroup,
  Checkbox,
  PasswordInput,
  NumberKeyboard,
  Icon,
  RadioGroup,
  Radio,
  Popup,
  DatetimePicker,
  Toast,
  ImagePreview,
  Uploader,
  List,
  Rate,
  Button,
  PullRefresh,
  Field,
  Dialog,
  Picker,
  Calendar,
  Loading,
  Switch,
  DropdownMenu,
  DropdownItem,
  CheckboxGroup,
  Search,
  Image as VanImage,
  ActionSheet,
  Empty, Form
} from "vant";

Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));
Vue.component("barcode", VueBarcode);
Vue.use(require("vue-wechat-title"));
Vue.use(dsbridge);
const FastClick = require("@/../static/js/fastclick.js");
FastClick.attach(document.body);

FastClick.prototype.focus = function(targetElement) {
  let length;
  if (
    targetElement.setSelectionRange &&
    targetElement.type.indexOf("date") !== 0 &&
    targetElement.type !== "time" &&
    targetElement.type !== "month"
  ) {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
};
Vue.use(Row)
  .use(Col)
  .use(Form)
  .use(Collapse)
  .use(CollapseItem)
  .use(NavBar)
  .use(Tab)
  .use(Tabs)
  .use(Cell)
  .use(CellGroup)
  .use(Checkbox)
  .use(PasswordInput)
  .use(NumberKeyboard)
  .use(Icon)
  .use(RadioGroup)
  .use(Radio)
  .use(Popup)
  .use(DatetimePicker)
  .use(Toast)
  .use(ImagePreview)
  .use(Uploader)
  .use(List)
  .use(Rate)
  .use(Button)
  .use(PullRefresh)
  .use(Field)
  .use(Dialog)
  .use(Picker)
  .use(Switch)
  .use(Calendar)
  .use(Loading)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Search)
  .use(ActionSheet )
  .use(Empty)
  .use(VanImage)
  .use(CheckboxGroup);
require("es6-promise").polyfill();
Vue.config.productionTip = false;

Vue.prototype.getStorage = localStorage.getItem;

/* eslint-disable no-new */

import permission from "@/directive/permission";
Vue.use(permission);

const vconsole = new VConsole({
  onReady: () => {
    if (process.env.NODE_ENV == "production") {
      vconsole.hideSwitch();
    }
  }
});
Vue.prototype.$vconsole = vconsole;

import wx from "weixin-js-sdk";

Vue.prototype.$isInMiniProgram = new Promise((resolve, reject) => {
  const ua = window.navigator.userAgent.toLowerCase();
  const isWeChat = ua.indexOf("micromessenger") !== -1;

  if (isWeChat) {
    wx.miniProgram.getEnv(env => {
      resolve(env.miniprogram);
    });
  } else {
    resolve(false);
  }
});

export default new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js